import { algoliasearch } from "algoliasearch";
import isSSR from "../isSSR";
import { createHttpRequester } from "@algolia/requester-node-http";
import { createFetchRequester } from "@algolia/requester-fetch";
import { useMemo } from "react";

export const primaryIndexName = "marketplace_listings";

export const hitsPerPage = 40;

export const useSearchClient = (remoteIp?: string) => {
  return useMemo(() => {
    const requester = isSSR()
      ? createHttpRequester({
          requesterOptions: {
            headers: {
              "X-Forwarded-For": remoteIp || undefined,
            },
          },
        })
      : createFetchRequester();

    return algoliasearch(process.env.client_algolia_app_id, process.env.client_algolia_search_key, {
      requester,
    });
  }, [remoteIp, isSSR()]);
};
